import {Component} from '@angular/core';
import {EvaluationComponent} from '../evaluation.component';
import {ECalculusStateFilter} from 'src/app/home/config/state-filter.enum';

@Component({
  selector: 'kpi4me-evaluation-client-access',
  templateUrl: './client-access.component.html',
  styleUrl: '../evaluation.component.scss',
  standalone: true
})
export class ClientAccessComponent extends EvaluationComponent {

  protected override _evaluationData: [number];
  protected override evaluationDisplayPercentages: [string];
  protected override evaluationDisplayAbsolute: [string];
  protected readonly ECalculusStateFilter = ECalculusStateFilter;

}
